const minSize = 16;
/**
 * Return size that is at least minSize and divisible by 8 for 8-point grid
 * @param {(string|number)} size
 * @param {number} minSize
 * @return {number} size for height and width
 */

const getIconSize = (avatarSize, size) => {
  if (size && typeof size === 'string') {
    switch (size) {
      case 'xs':
      case 'sm':
        return 0;

      case 'md':
        return 1;

      case 'lg':
        return 2;

      default:
        return 1;
    }
  } // return Math.ceil(avatarSize / 2);


  const properSize = size < minSize ? minSize : size;
  return 8 * Math.round(properSize / 8);
};

export default getIconSize;